export default __webpack_public_path__ + "static/media/speed.1b51007b.svg";